import * as React from "react";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";

const ErrorPage: React.FC = () => {
    const { fileUploadData } = useFileUploadInfoData();

    return (
        <div style={{marginTop: "25%", textAlign: "center"}}>
            {fileUploadData.returnedError === "UnexpectedError" 
                ?<div> <strong>Unexpected Error. Contact production support, please.</strong>
                    <br/>
                    <h2>Contact</h2>
                    <div className="widget-content">
                        <h3>Tax Help Desk</h3>
                        <p>
                            <a href="mailto:tax@clearstream.com">tax@clearstream.com</a>
                        </p>
                        <p>Phone: +352 -243 -3 2835</p>
                    </div>
            </div>
                : <strong>There has been a problem when uploading the file. </strong>
            }            
            <br/>
            <br/>
            {fileUploadData.returnedError === "EmailError" &&
                "File had been successfully uploaded but there was an error when sending confirmation email."
            }
            {fileUploadData.returnedError === "FileContainsVirus" &&
                "File had not been uploaded because the file contains a virus."
            }
            {fileUploadData.returnedError === "EnqueueError" &&
                "File had not been uploaded. Contact Production Support, please."
            }
            {fileUploadData.returnedError === "WrongFileExtension" &&
                "File had not been uploaded. The extension is not allowed."
            }
            {fileUploadData.returnedError === "FileContentError" &&
                "File had not been uploaded. Check that the content of the file follows the template rules, please."
            }

        </div>
        
    );
};

export default ErrorPage;
